import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/featureAccess/customer.featureAccess.set.mutation.gql"
import type {
  CustomerFeatureAccessSetMutation,
  CustomerFeatureAccessSetMutationVariables,
} from "@/v2-backoffice-client/customer/featureAccess/__types__/customer.featureAccess.set.mutation"

type Options = MutationHookOptions<
  CustomerFeatureAccessSetMutation,
  CustomerFeatureAccessSetMutationVariables
>

export function useCustomerFeatureAccessSetMutation(options?: Options) {
  return useMutation<
    CustomerFeatureAccessSetMutation,
    CustomerFeatureAccessSetMutationVariables
  >(mutation, options)
}
